import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import faqsIcon from "../../Assets/joinNow.png";
import AntRobotImg from "../../Assets/AntImg.png";
import RobotImg from "../../Assets/Robo.png";

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(1);

  const faqItems = [
    {
      title: "Consultation Booking System",
      content:
        "Rhoncus duis urna lobortis at fusce cum accumsan tempor ads orci etiam litora dignissim ipsum lacinia hendrerit convallis vitae Consequat enim phasellus purus",
    },
    {
      title: "Personalized Dashboard",
      content:
        "Rhoncus duis urna lobortis at fusce cum accumsan tempor ads orci etiam litora dignissim ipsum lacinia hendrerit convallis vitae Consequat enim phasellus purus",
    },
    {
      title: "AI Insights And Analytics",
      content:
        "Rhoncus duis urna lobortis at fusce cum accumsan tempor ads orci etiam litora dignissim ipsum lacinia hendrerit convallis vitae Consequat enim phasellus purus",
    },
  ];

  return (
    <motion.div
      className="py-4 sm:py-6 md:py-8 lg:py-10 xl:py-12 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 bg-white"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8 }}
    >
      <div className="max-w-screen-2xl mx-auto flex flex-col lg:flex-col xl:flex-row gap-6 lg:gap-12 items-center">
        {/* Left Column: Images */}
        <div className="flex-1 relative w-full flex justify-center lg:justify-start order-1 lg:order-2 xl:order-1">
          <div className="flex lg:grid lg:grid-cols-2 xl:flex items-center gap-4 w-full">
            {/* Smaller floating image */}
            <motion.div
              className="w-[140px] sm:w-[180px] md:w-[240px] lg:w-full xl:w-[240px] h-[220px] sm:h-[300px] md:h-[400px] lg:h-[500px] xl:h-[400px] overflow-hidden rounded-3xl sm:rounded-[40px] shadow-xl mt-10 sm:mt-20 lg:mt-0 xl:mt-20 hidden sm:block"
              initial={{ opacity: 0, x: -40, scale: 0.92 }}
              whileInView={{ opacity: 1, x: 0, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: 0.2 }}
              whileHover={{ scale: 1.04, y: -6 }}
            >
              <img
                src={AntRobotImg}
                alt="AI Ant"
                className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
              />
            </motion.div>

            {/* Main large image */}
            <motion.div
              className="flex-1 lg:w-full h-[300px] sm:h-[420px] md:h-[600px] lg:h-[500px] xl:h-[600px] overflow-hidden rounded-3xl sm:rounded-[40px] shadow-2xl"
              initial={{ opacity: 0, scale: 0.94 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.3 }}
              whileHover={{ scale: 1.03 }}
            >
              <img
                src={RobotImg}
                alt="AI Robot"
                className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
              />
            </motion.div>
          </div>

          {/* Glow */}
          <motion.div
            className="absolute -left-10 top-1/2 -translate-y-1/2 w-24 sm:w-32 h-24 sm:h-32 bg-green-200/40 blur-[80px] -z-10 rounded-full"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.4, delay: 0.4 }}
          />
        </div>

        {/* Right Column: Content */}
        <div className="flex-1 w-full order-2 lg:order-1 xl:order-2">
          {/* Badge */}
          <div className="flex items-center gap-2 mb-1 sm:mb-2 md:mb-3 lg:mb-4 xl:mb-5 bg-white/50 w-fit">
            <img src={faqsIcon} alt="FAQ Icon" className="h-8 sm:h-10" />
            <span className="text-[11px] sm:text-[12px] font-bold tracking-[0.2em] text-brandDark">
              FAQ'S
            </span>
          </div>

          {/* Heading */}
          <motion.h2
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-brandDark mb-8 sm:mb-12 leading-tight"
            initial={{ opacity: 0, y: 35 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.1 }}
          >
            Harnessing AI For <br />
            <span className="text-brandOrange font-serif italic font-normal">
              Business
            </span>
          </motion.h2>

          {/* Accordion List */}
          <div className="space-y-3 sm:space-y-4">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className={`border-b border-gray-100 transition-all duration-300 ${
                  openIndex === index ? "pb-6 sm:pb-8" : "pb-4"
                }`}
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                  className="w-full flex justify-between items-center text-left group"
                >
                  <motion.span
                    className={`text-lg sm:text-xl lg:text-2xl font-bold transition-colors ${
                      openIndex === index
                        ? "text-brandDark"
                        : "text-brandDark/70 group-hover:text-brandDark"
                    }`}
                    animate={{
                      color:
                        openIndex === index ? "#000000" : "rgba(0,0,0,0.7)",
                    }}
                    transition={{ duration: 0.4 }}
                  >
                    {item.title}
                  </motion.span>
                  <motion.span
                    className="text-2xl font-light text-[#00A3FF]"
                    animate={{ rotate: openIndex === index ? 180 : 0 }}
                    transition={{ duration: 0.4 }}
                  >
                    {openIndex === index ? "—" : "+"}
                  </motion.span>
                </button>

                {/* Answer */}
                <AnimatePresence>
                  {openIndex === index && (
                    <motion.div
                      className={`overflow-hidden`}
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.5, ease: "easeInOut" }}
                    >
                      <div className="mt-4 sm:mt-6">
                        <p className="text-gray-400 text-sm sm:text-base leading-relaxed max-w-xl">
                          {item.content}
                        </p>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default FAQs;
